import "./Footer.scss";
export default function Footer() {
  return (
    <footer className="footer">
      <hr></hr>
      <div className="footer-text">
        <span>Copyright© 2023 kt cloud corp. All rights reserved.</span>
      </div>
    </footer>
  );
}
